import CXMApiClient from "../../CXMApiClient";
import {
  setCurrentVehicle,
  setReplacementVehicle,
  setCurrentVehicleNew
} from "../../../lib/utilities/helpers/garageVehicles";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";
import Vue from "vue";

function initialState() {
  return {
    AllContactOwnedVehicles: [],
    AddTradeInGarageInfoModal: {
      showModal: false,
      emitMethodtype: null,
      contact: null,
      vehicle: null
    },
    GarageVehicleStatusModalInfo: {
      ShowModal: false,
      Title: "",
      Description: "",
      Data: "",
      AccountPlatformId: "",
      PageType: null
    },
    MarkAsSoldModalInfo: {
      ShowModal: false,
      Data: null
    },
    PurchasedByDealerModalInfo: {
      ShowModal: false,
      Data: null
    },
    BehindTheScoreModalInfo: {
      ShowModal: false,
      entityScoreFeatures: []
    },
    VehicleHistoryModal: {
      ShowModal: false,
      Reporter: null,
      Url: null,
      Vin: null,
      DealerId: null
    },
    UpdatePayoffModal: {
      ShowModal: false,
      EntityId: null
    },
    UpdateMileageModal: {
      ShowModal: false,
      EntityId: null
    },
    GarageData: [],
    InitialGarageData: [],
    appraisalModalInfo: {
      showModal: false,
      data: null
    },
    VAutoSettings: [],
    VinCueSettings: [],
    AllDealerIntegrations: [],
    AllDealersCountryCodes: [],
    RecallData: [],
    recallDetailsModalInfo: {
      showModal: false,
      data: null,
      hasFordOasis: false
    },
    fordTagDetailsModalInfo: {
      showModal: false,
      data: null,
      type: null
    }
  };
}

const state = initialState();

const getters = {
  AllContactOwnedVehicles(state) {
    return state.AllContactOwnedVehicles;
  },
  AllCurrentlyOwnedVehicles(state) {
    return state.AllContactOwnedVehicles &&
      state.AllContactOwnedVehicles.length > 0
      ? state.AllContactOwnedVehicles.filter(vehicle => !vehicle.noLongerOwns)
      : [];
  },
  AllPreviouslyOwnedVehicles(state) {
    return state.AllContactOwnedVehicles &&
      state.AllContactOwnedVehicles.length > 0
      ? state.AllContactOwnedVehicles.filter(vehicle => vehicle.noLongerOwns)
      : [];
  },

  GarageData: function() {
    return state.GarageData;
  },
  InitialGarageData: function() {
    return state.InitialGarageData;
  },
  MarkAsSoldModalInfo(state) {
    return state.MarkAsSoldModalInfo;
  },
  PurchasedByDealerModalInfo(state) {
    return state.PurchasedByDealerModalInfo;
  },
  GarageVehicleStatusModalInfo(state) {
    return state.GarageVehicleStatusModalInfo;
  },
  BehindTheScoreModalInfo(state) {
    return state.BehindTheScoreModalInfo;
  },
  VehicleHistoryModal: function() {
    return state.VehicleHistoryModal;
  },
  UpdatePayoffModal: function(state) {
    return state.UpdatePayoffModal;
  },
  UpdateMileageModal: function(state) {
    return state.UpdateMileageModal;
  },
  VAutoSettings: function(state) {
    return state.VAutoSettings;
  },
  VinCueSettings: function(state) {
    return state.VinCueSettings;
  },
  AllDealerIntegrations: function(state) {
    return state.AllDealerIntegrations;
  },
  AllDealersCountryCodes: function(state) {
    return state.AllDealersCountryCodes;
  }
};

const actions = {
  addOrUpdateCustomerVehicle(context, request) {
    let vm = this;
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      await client
        .ProcessRequest(
          "post",
          `/crm/contacts/${request.contactId}/vehicles/current_vehicles`,
          request.vehicle
        )
        .then(response => {
          if (response && response.data) {
            resolve(response);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getCustomerVehicles(context, request) {
    let vm = this;
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      await client
        .ProcessRequest(
          "get",
          `/crm/contacts/${request.contactId}/vehicles/current_vehicles`
        )
        .then(response => {
          if (response && response.data) {
            resolve(response);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  async getOfferStatuses(context, request) {
    let client = new CXMApiClient();
    let response = await client.ProcessRequest(
      "post",
      `/api/Dealsheet/entity/offer_status`,
      request
    );
    return response && response.data ? response.data.data : null;
  },
  getGarageData(context, request) {
    // TODO: Get all vehicles if more than the requested size are present
    let vm = this;
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      await client
        .ProcessRequest("post", `/api/vehicle/garage/garage_vehicles`, request)
        .then(response => {
          if (response && response.data) {
            response.data.data.forEach(vehicle => {
              vehicle.hasoffer = false;
            });
            context.commit("updateInitialGarageData", response.data.data);
            context.commit("updateGarageData", response.data.data);
            resolve(response);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  async getEnterpriseGarageVehicles(context, contactId) {
    let client = new CXMApiClient();
    const requestPayload = {
      contactId: contactId,
      pagination: {
        pageNumber: 0,
        pageSize: 50
      },
      sortField: {
        sortBy: "entityId"
      }
    };

    return await client
      .ProcessRequest(
        "post",
        `/api/vehicle/garage/enterprise_garage_vehicles`,
        requestPayload
      )
      .catch(err => err.response);
  },
  getGarageTabIntegrationsByPlatformId(context, platformId) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "GET",
          `api/dealsheet/integrations/dealer_enabled_integrations/${platformId}`,
          null,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful && resp.data.data) {
            context.commit("updateDealerIntegrations", {
              platformId: platformId,
              integrations: resp.data.data
            });
            resolve(resp.data.data);
          } else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  postUnwind(context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest("post", "/api/Dealsheet/unwind", request)
        .then(response => {
          return resolve(response.data.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  clearGarageVehicleStatusModal(context) {
    context.commit("clearGarageVehicleStatusModal");
  },
  setGarageVehicleStatusModalInfo(context, val) {
    context.commit("setGarageVehicleStatusModalInfo", val);
  },
  setMarkAsSoldModalInfo(context, val) {
    context.commit("setMarkAsSoldModalInfo", val);
  },
  clearMarkAsSoldModalInfo(context, val) {
    context.commit("clearMarkAsSoldModalInfo", val);
  },
  setPurchasedByDealerModalInfo(context, val) {
    context.commit("setPurchasedByDealerModalInfo", val);
  },
  clearPurchasedByDealerModalInfo(context, val) {
    context.commit("clearPurchasedByDealerModalInfo", val);
  },
  setBehindTheScoreModal(context, val) {
    context.commit("setBehindTheScoreModal", val);
  },
  clearBehindTheScoreModal(context) {
    context.commit("clearBehindTheScoreModal");
  },
  setSelectedContract(context, val) {
    context.commit("setSelectedContract", val);
  },

  getVehicleHistoryInfo(context, url) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("GET", `api/dealsheet/integrations/${url}`, null, scope)
        .then(resp => {
          if (resp.data && resp.data.successful && resp.data.data)
            resolve(resp.data.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  markVehicleNoLongerOwns(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          `api/dealsheet/entity/${request.entityId}/customer_does_not_own_vehicle/`,
          null,
          request.scope ? [request.scope] : []
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  reopenDealsheet(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          `/api/vehicle/garage/reopen`,
          request,
          request.scope ? [request.scope] : []
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  purchasedByDealer(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          `/api/vehicle/garage/dealer_purchased`,
          request,
          request.scope ? [request.scope] : []
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  contactNoLongerOwns(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          `/api/vehicle/garage/customer_does_not_own_vehicle`,
          request,
          []
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  markAsSold(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          `/api/Dealsheet/entity/${request.entityId}/mark_as_sold`,

          []
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  contactOwnsVehicle(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          `/api/vehicle/garage/contact_owns_vehicle`,
          request,
          []
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  updatePayoff(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          `/api/vehicle/current/update_payoff`,
          request,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  updateMileage(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          `/api/vehicle/current/update_mileage`,
          request,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  updateTrade(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          `/api/vehicle/current/log_trade_value_change`,
          request,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  updateReplacementPrice(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          `/api/vehicle/replacement/log_price_change`,
          request,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  recalcDealsheet(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();

    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          `/api/opportunities/payment_recalc`,
          request,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful) {
            let data = {
              entityId: request.entityID,
              defaultContract: resp.data.data.defaultContract,
              contracts: resp.data.data.contracts
            };
            context.commit("updateDealsheetCalculations", data);

            resolve(resp.data.data);
          } else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  openVehicleHistoryModal(context, data) {
    context.commit("openVehicleHistoryModal", data);
  },
  closeVehicleHistoryModal(context) {
    context.commit("closeVehicleHistoryModal");
  },
  openUpdatePayoffModal(context, data) {
    context.commit("openUpdatePayoffModal", data);
  },
  closeUpdatePayoffModal(context) {
    context.commit("closeUpdatePayoffModal");
  },
  openUpdateMileageModal(context, data) {
    context.commit("openUpdateMileageModal", data);
  },
  closeUpdateMileageModal(context) {
    context.commit("closeUpdateMileageModal");
  },
  clearGarageData(context) {
    context.commit("clearGarageData");
  },
  updateGarageData(context, data) {
    context.commit("updateGarageData", data);
  },

  checkIfStoreHasVinCueEnabled: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();

    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("POST", "/api/vincue/VinCue_is_enabled", request, scope)
        .then(resp => {
          if (resp.data && resp.data.successful) {
            context.commit("updateVinCueSettings", resp.data.data);
            resolve(resp.data.data);
          } else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  checkIfStoreHasvAutoEnabled: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();

    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("POST", "/api/VAuto/is_enabled", request, scope)
        .then(resp => {
          if (resp.data && resp.data.successful) {
            context.commit("updatevAutoSettings", resp.data.data);
            resolve(resp.data.data);
          } else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  updateAppraisalModalInfo: function(context, data) {
    context.commit("updateAppraisalModalInfo", data);
  },
  getVAutoAppraisalDetailsByVin: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();

    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/VAuto/appraisal/get_latest_by_vin",
          request,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getVinCueAppraisalDetailsByVin: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();

    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/VinCue/appraisal/get_latest_by_vin",
          request,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  sendForAppraisalVAutoV1: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();

    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("POST", "/api/VAuto/appraisal/create", request, scope)
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  sendForAppraisal: async function(context, request) {
    const cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient
      .ProcessRequest("POST", "/api/VAuto/appraisal/createV2", request)
      .catch(err => err.response);
    if (
      response &&
      response.data &&
      response.data.successful &&
      response.data.data
    ) {
      return response.data.data;
    }

    return null;
  },
  getVAutoUsers: async function(context, request) {
    const cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient
      .ProcessRequest(
        "GET",
        "/api/VAuto/appraisal/GetUsers?dealerId=" + request
      )
      .catch(err => err.response);

    if (
      response &&
      response.data &&
      response.data.successful &&
      response.data.data
    ) {
      return response.data.data;
    }
    return null;
  },
  sendForAppraisalVinCue: async function(context, request) {
    const cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient
      .ProcessRequest("POST", "/api/VinCue/appraisal/createVinCue", request)
      .catch(err => err.response);

    if (
      response &&
      response.data &&
      response.data.successful &&
      response.data.data
    ) {
      return response.data.data;
    }

    return null;
  },
  submitFordOasisRequest: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();

    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/dealsheet/integrations/submit_oasis",
          request,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getPlatformDetails: function(context, platformId) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("/platform/" + platformId)
        .then(response => {
          if (response && response.data && response.data.Data) {
            context.commit("updatePlatformDetails", response.data.Data);
            resolve(response);
          } else reject(response);
        })
        .catch(ex => {
          reject(ex);
        });
    });
  },
  submitSmartVincentRequest: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();

    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/dealsheet/integrations/submit_smart_vincent",
          request,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },

  getAverageVehicle: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/vehicle/garage/average_vehicle",
          request,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getRecallDetails: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();

    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("POST", "/api/recalls/full", request, scope)
        .then(resp => {
          if (resp.data && resp.data.successful) {
            let data = {
              response: resp.data.data,
              request: request
            };
            context.commit("updateRecallInformationForVehicle", data);
            resolve(resp.data.data);
          } else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  clearContactRecallData: function(context) {
    context.commit("updateRecallInformationForVehicle", null);
  },
  updateRecallDataModalInfo: function(context, data) {
    context.commit("updateRecallDataModalInfo", data);
  },
  updateFordTagDetailsModalInfo: function(context, data) {
    context.commit("updateFordTagDetailsModalInfo", data);
  },
  updateTradeInGarageInfoModal: function(context, data) {
    context.commit("updateTradeInGarageInfoModal", data);
  },
  updateAllContactOwnedVehicles: function(context, data) {
    context.commit("updateAllContactOwnedVehicles", data);
  },
  clearAllContactOwnedVehicles(context) {
    context.commit("clearAllContactOwnedVehicles");
  },
  async getSavedGarageVehicleTradeValue(context, vehicleId) {
    let response = await new CXMApiClient().ProcessRequest(
      "POST",
      `/api/vehicle/garage/get_vehicle_trade_value/${vehicleId}`
    );
    return response && response.data ? response.data.data : null;
  },
  async saveGarageVehicleTradeValue(context, payload) {
    let response = await new CXMApiClient().ProcessRequest(
      "POST",
      `/api/vehicle/garage/store_vehicle_trade_value`,
      payload
    );
    return response && response.data ? response.data.data : null;
  },
  async resetGarageVehicleTradeValue(context, request) {
    let response = await new CXMApiClient().ProcessRequest(
      "POST",
      `/api/vehicle/garage/reset_vehicle_trade_value`,
      request
    );
    return response && response.data ? response.data.data : null;
  },
  getCustomerVOILeads(context, contactId) {
    let vm = this;
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      await client
        .ProcessRequest("get", `/crm/contacts/${contactId}/vehicles`)
        .then(response => {
          if (response && response.data) {
            resolve(response);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

const mutations = {
  updateAllContactOwnedVehicles: function(state, data) {
    state.AllContactOwnedVehicles = data;
  },
  clearAllContactOwnedVehicles(state) {
    state.AllContactOwnedVehicles = [];
  },

  updateTradeInGarageInfoModal: function(state, data) {
    if (!data.showModal) {
      data.emitMethodtype = null;
      data.contact = null;
    }
    state.AddTradeInGarageInfoModal = data;
  },
  updateDealsheetCalculations: function(state, data) {
    if (state.GarageData && state.GarageData.length > 0) {
      let dealsheet = state.GarageData.find(gd => {
        return (
          gd.currentVehicle.entityId.toLowerCase() ==
          data.entityId.toLowerCase()
        );
      });
      if (dealsheet) {
        dealsheet.paymentCalc.defaultContract = data.defaultContract || {};
        dealsheet.paymentCalc.contracts = data.contracts;
      }
    }
  },
  updateGarageData: function(state, data) {
    state.GarageData = data;
  },
  clearGarageVehicleStatusModal(state) {
    state.GarageVehicleStatusModalInfo.ShowModal = false;
    state.GarageVehicleStatusModalInfo.Title = null;
    state.GarageVehicleStatusModalInfo.Description = null;
    state.GarageVehicleStatusModalInfo.Data = null;
    state.GarageVehicleStatusModalInfo.AccountPlatformId = null;
    state.GarageVehicleStatusModalInfo.PageType = null;
  },
  setGarageVehicleStatusModalInfo(state, val) {
    let title = val.ShowModal
      ? val.Title + val.Data.year + " " + val.Data.make + " " + val.Data.model
      : val.Title;

    state.GarageVehicleStatusModalInfo.ShowModal = val.ShowModal;
    state.GarageVehicleStatusModalInfo.Title = title;
    state.GarageVehicleStatusModalInfo.Description = val.Description;
    state.GarageVehicleStatusModalInfo.Data = val.Data;
    state.GarageVehicleStatusModalInfo.AccountPlatformId =
      val.AccountPlatformId;
    state.GarageVehicleStatusModalInfo.PageType = val.PageType;
  },
  clearBehindTheScoreModal(state) {
    state.BehindTheScoreModalInfo = {
      ShowModal: false,
      entityScoreFeatures: []
    };
  },
  setSelectedContract(state, val) {
    let dealsheet = state.GarageData.find(gd => {
      return gd.currentVehicle.entityId == val.entityId;
    });
    dealsheet.paymentCalc.defaultContract = val.contract;
  },
  setMarkAsSoldModalInfo(state, val) {
    state.MarkAsSoldModalInfo = val;
  },
  clearMarkAsSoldModalInfo(state) {
    state.MarkAsSoldModalInfo = {
      ShowModal: false,

      Data: null
    };
  },
  setPurchasedByDealerModalInfo(state, val) {
    state.PurchasedByDealerModalInfo = val;
  },
  clearPurchasedByDealerModalInfo(state) {
    state.PurchasedByDealerModalInfo = {
      ShowModal: false,

      Data: null
    };
  },
  setBehindTheScoreModal(state, val) {
    state.BehindTheScoreModalInfo = val;
  },
  openVehicleHistoryModal(state, data) {
    state.VehicleHistoryModal.ShowModal = true;
    state.VehicleHistoryModal.Reporter = data.name;
    state.VehicleHistoryModal.Url = data.vehicleHistoryUrl;
    state.VehicleHistoryModal.Vin = data.vin;
    state.VehicleHistoryModal.DealerId = data.dealerId;
  },
  closeVehicleHistoryModal(state) {
    state.VehicleHistoryModal.ShowModal = false;
    state.VehicleHistoryModal.Reporter = null;
    state.VehicleHistoryModal.Url = null;
    state.VehicleHistoryModal.Vin = null;
    state.VehicleHistoryModal.DealerId = null;
  },
  openUpdatePayoffModal(state, data) {
    state.UpdatePayoffModal.ShowModal = true;
    state.UpdatePayoffModal.EntityId = data.EntityId;
  },
  closeUpdatePayoffModal(state) {
    state.UpdatePayoffModal.ShowModal = false;
    state.UpdatePayoffModal.EntityId = null;
  },
  openUpdateMileageModal(state, data) {
    state.UpdateMileageModal.ShowModal = true;
    state.UpdateMileageModal.EntityId = data.EntityId;
  },
  closeUpdateMileageModal(state) {
    state.UpdateMileageModal.ShowModal = false;
    state.UpdateMileageModal.EntityId = null;
  },
  clearGarageData(state) {
    state.GarageData = [];
    state.InitialGarageData = [];
  },
  updateVinCueSettings: function(state, data) {
    state.VinCueSettings.push(data);
  },
  updatevAutoSettings: function(state, data) {
    state.VAutoSettings.push(data);
  },
  updateAppraisalModalInfo: function(state, data) {
    state.appraisalModalInfo = data;
  },
  updateInitialGarageData: function(state, data) {
    state.InitialGarageData = JSON.parse(JSON.stringify(data));
  },
  updateDealerIntegrations: function(state, data) {
    let activeIntegrations = data.integrations
      ? data.integrations.filter(x => x.isConfigured)
      : [];
    state.AllDealerIntegrations.push({
      accountPlatformId: data.platformId,
      integrations: activeIntegrations
    });
  },
  updatePlatformDetails: function(state, data) {
    let platformLite = {
      accountPlatformId: data.AccountPlatformID,
      countryId: data.CountryID
    };
    state.AllDealersCountryCodes.push(platformLite);
  },
  updateRecallInformationForVehicle: function(state, data) {
    if (!data) {
      state.RecallData = [];
    } else {
      let response = data.response;
      let entityId = data.request.entityId;
      state.RecallData.push({
        entityId: entityId,
        recallData: response
      });
    }
  },
  updateRecallDataModalInfo: function(state, data) {
    state.recallDetailsModalInfo = data;
  },
  updateFordTagDetailsModalInfo: function(state, data) {
    state.fordTagDetailsModalInfo = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/customerdashboard/Garage.js